import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AppRoutes from 'components/core/AppRoutes';
import { basePath } from 'config';
import HttpAlertDialog from 'components/core/HttpAlertDialog';
import AppLoading from 'components/core/AppLoading';
import { loadLocalisationConfigs } from 'ducks/localisation';
import { MuiPickersUtilsProvider } from '@ds/react-components';
import moment from 'moment';
import MomentUtils from '@date-io/moment';

moment.locale('en');

const App = (props) => {
  const { loadLocalisationConfigs } = props;
  useEffect(() => {
    loadLocalisationConfigs();
  }, [loadLocalisationConfigs]);

  return (
    <BrowserRouter basename={basePath}>
      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
        <HttpAlertDialog />
        <AppLoading />
        <AppRoutes />
      </MuiPickersUtilsProvider>
    </BrowserRouter>
  );
};

export default connect(null, {
  loadLocalisationConfigs,
})(App);
